// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {applySearchFilters} from './facets';
import {getPipProductsSearchResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';
import {routerActions} from 'react-router-redux';

export const updatePinSearchResults = (query, searchBy) =>

    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const searchResults = await getPipProductsSearchResults(query, searchBy);

            const allowedDealers = getState().user.details.settings.dealer.accounts.selectedAccounts;

            dispatch({
                data: searchResults,
                type: actions.UPDATE_PIP_SEARCH_RESULTS_SUCCESS
            });

            dispatch({
                data: searchResults,
                type: actions.FILTER_PIP_SEARCH_RESULTS
            });

            dispatch({
                searchByType: 'PIN',
                type: actions.UPDATE_PIP_SEARCH_BY_TYPE
            });

            dispatch({
                hasSearchResults: true,
                type: actions.UPDATE_PIP_HAS_SEARCH_RESULTS
            });

            dispatch(routerActions.push(`/pips/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

            dispatch({
                isValidDealer: allowedDealers.some(dealer => dealer === searchResults[0].responsibleAccount.account),
                type: actions.UPDATE_PIP_SEARCH_IS_VALID_DEALER
            });

            if (getState().pips.pipSearch.facets.pipTypesFacet.allowedTypes.length > 0) {

                applySearchFilters(getState().pips.pipSearch)(dispatch);

            }

            if (!getState().exportToExcel.selectedExcelLayout.pipProductSearch.name) {

                readExcelLayouts('pipProductSearch')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/pin-search.js